import { gql } from "lib/apolloClient";

export const sendChannelMessageMutation = gql`
  mutation sendChannelMessage($input: ChannelMessageInput!) {
    platform {
      sendChannelMessage(input: $input)
    }
  }
`;
